// should become New feature
export const getObjectName: (name: string) => string = (name: string): string => {
	let objectName = name;

	// replace any hyphens with spaces
	// and capitalise only the first letter
	if (objectName) {
		objectName = objectName.replace(/-/g, ' ');
		objectName = objectName.charAt(0).toUpperCase() + objectName.slice(1);
	}

	return objectName;
};
